import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import LanguageIcon from "@mui/icons-material/Language";
import InstagramIcon from "@mui/icons-material/Instagram";

export const sourceIcon = (source) => {
  const s = (source || "").toLowerCase();
  if (s.includes("facebook")) return <FacebookIcon fontSize="small" />;
  if (s.includes("google")) return <GoogleIcon fontSize="small" />;
  if (s.includes("instagram")) return <InstagramIcon fontSize="small" />;
  if (s.includes("website")) return <LanguageIcon fontSize="small" />;
  return <LanguageIcon fontSize="small" />;
};

export const initials = (name) => {
  const n = (name || "").trim();
  if (!n) return "L";
  const parts = n.split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase()).join("");
};

export const fmtDateParts = (d) => {
  if (!d) return null;
  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return null;
  const m = date.toLocaleString("en-US", { month: "short" });
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  const t = date
    .toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })
    .replace(" ", "");
  return { top: `${m} ${day},`, mid: `${year}`, bot: t };
};

export const pick = (obj, paths, fallback = "") => {
  for (const p of paths) {
    let cur = obj;
    let ok = true;
    for (const part of p.split(".")) {
      if (cur && Object.prototype.hasOwnProperty.call(cur, part))
        cur = cur[part];
      else {
        ok = false;
        break;
      }
    }
    if (ok && cur !== undefined && cur !== null && String(cur).trim() !== "")
      return cur;
  }
  return fallback;
};

const hasNonRnrCall = (lead) => {
  const logs = Array.isArray(lead?.call_logs) ? lead.call_logs : [];
  return logs.some((c) => c && c.rnr === false);
};

export const normalizeLead = (l) => {
  const servicesArr = Array.isArray(l?.services)
    ? l.services.filter(Boolean)
    : l?.services
      ? [l.services]
      : [];

  const ae = l?.assign_employee;

  const telecallerId =
    (ae && typeof ae === "object"
      ? ae._id || ae.id || ae.userId || ae.value
      : ae) || "";

  const telecallerName =
    ae && typeof ae === "object" ? ae.name || ae.label || ae.full_name : "";

  const telecallerTeam =
    ae && typeof ae === "object" ? ae.team || ae.team_name : "";

  const firstContactAt = l?.sla?.first_contact_at || "";

  const nonRnr = hasNonRnrCall(l);

  const untouchedBySla = !firstContactAt || !nonRnr;

  return {
    _raw: l,
    _id: l?._id,
    name: pick(l, ["client_name", "name", "full_name"], "") || "Unnamed Lead",
    phone: pick(l, ["contact", "phone", "phone_number"], ""),
    email: pick(l, ["email", "contact.email"], ""),
    location: l?.custom_fields?.city,
    priority: l?.priority,
    source:
      pick(l, ["source", "custom_fields.lead_source", "lead_source"], "") ||
      "Unknown",
    services: servicesArr,
    treatmentType: servicesArr.length ? servicesArr.join(", ") : "—",
    telecallerId,
    telecaller: telecallerName || "",
    telecallerTeam,
    responseLabel: l?.current_status?.key || "",
    createdAt: l?.createdAt || l?.created_at || "",
    current_status: l?.current_status || null,

    firstContactAt,
    hasNonRnrCall: nonRnr,
    untouchedBySla,
  };
};
